// extracted by mini-css-extract-plugin
export default {"banner_item":"Card_banner_item__W-8jL","banner_item__img":"Card_banner_item__img__Wzu8B","call_to_action":"Card_call_to_action__VOE9G"};